import { ConsentDashboard } from "@/features/consents";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod/v4";
import type { ConsentProductType, ConsentStatus } from "../../../api/types";
import { isomorphicHttpClient } from "../../../httpClient";
import { verifyRoles } from "../../../utils/verifyRoles";

const consentsFiltersSearchParamsSchema = z.object({
  tenantId: z.string().default("").catch(""),
  productType: z
    .array(
      z.enum([
        "AUTOMATIC_PAYMENT",
        "CUSTOMER_DATA",
        "INSTANT_SCHEDULED_PAYMENT",
        "ENROLLMENT",
      ] as const satisfies ConsentProductType[]),
    )
    .default([])
    .catch([]),
  status: z
    .array(
      z.enum([
        "AUTHORISED",
        "AWAITING_AUTHORISATION",
        "AWAITING_ACCOUNT_HOLDER_VALIDATION",
        "AWAITING_RISK_SIGNALS",
        "AWAITING_ENROLLMENT",
        "REJECTED",
        "PARTIALLY_ACCEPTED",
        "AWAITING_ACCOUNT_HOLDER_VALIDATION",
        "AWAITING_RISK_SIGNALS",
        "AWAITING_ENROLLMENT",
        "REVOKED",
        "CONSUMED",
      ] as const satisfies ConsentStatus[]),
    )
    .default([])
    .catch([]),
  startDate: z.iso.datetime().optional().catch(undefined),
  endDate: z.iso.datetime().optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/consents/")({
  component: ConsentDashboard,
  head: () => ({
    meta: [{ title: "Consentimentos - Backoffice Detentora Iniciador" }],
  }),
  validateSearch: consentsFiltersSearchParamsSchema,
  search: {
    middlewares: [
      stripSearchParams(consentsFiltersSearchParamsSchema.parse({})),
    ],
  },
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN", "ORG_OPERATOR"]),
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["tenants"],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/tenants");

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
